var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurplePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8673,
    cy: 39.2794,
    r: 39.2345,
    fill: "url(#paint0_linear_1201_36098)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8673,
    cy: 39.2794,
    r: 37.2175,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 4.03397
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7384 56.0606C31.5928 56.0606 30.0602 54.3747 30.0602 52.3823V25.4086C30.0602 23.4929 31.5928 21.807 33.7384 21.807C34.3514 21.807 35.0411 21.9603 35.6541 22.3434L57.7235 35.8303C58.7964 36.4433 59.486 37.6694 59.486 38.8955C59.486 40.1982 58.7964 41.4243 57.7235 42.0373L35.6541 55.5241C35.0411 55.9073 34.3514 56.0606 33.7384 56.0606Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1201_36098",
    x1: 26.2496,
    y1: 78.5139,
    x2: 79.1018,
    y2: 25.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePlay);
export default __webpack_public_path__ + "static/media/purplePlay.11d637b8cba205fa25130642efa04875.svg";
export { ForwardRef as ReactComponent };